import SearchIcon from '@mui/icons-material/Search';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { alpha, styled } from '@mui/material/styles';
import React from 'react';
import Link from '@mui/material/Link';
import { ROUTES } from '../routes/routes.tsx';

interface NavItem {
  label: string;
  path: string;
}

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}));
  
const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
  
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));

const navItems: NavItem[] = [
  { label: 'Our Products', path: ROUTES.PRODUCT },
  { label: 'About Us', path: '/aboutUs' },
  { label: 'For Vendors', path: '/forVendors' },
  { label: 'Design With AI', path: '/designWithAI' },
];

interface NavbarProps {
}

const Navbar: React.FC<NavbarProps> = () => {
  return (
    <AppBar position="static" style={{ backgroundColor: '#957db9', height: '7vh' }}>
      <Toolbar style={{ width: '90%', margin: 'auto' }}>
        {/* Logo Section */}
        <Link href={ROUTES.HOME} style={{ textDecoration: 'none', color: 'white' }} underline="none">
          <IconButton color="inherit" aria-label="logo" style={{ paddingLeft: 0 }} disableRipple>
            <img src={'/MZLogo.png'} alt="Logo" style={{ height: 40 }} />
          </IconButton>
        </Link>
        <Link href={ROUTES.HOME} style={{ textDecoration: 'none', flexGrow: 1, color: 'white' }} underline="none">
          <Typography variant="h6" style={{ flexGrow: 1, fontWeight: 'bold' }}>
            MerchZ
          </Typography>
        </Link>

        {/* Navigation Links */}
        <div style={{ display: 'flex', gap: '16px' }}>
          {navItems.map((item, index) => (
            <Link href={item.path} key={index} style={{ textDecoration: 'none', color: 'white' }} underline="none">
              <Button key={index} color="inherit" style={{ fontWeight: 'bold', textTransform: 'none' }}>
                {item.label}
              </Button>
            </Link>
          ))}
        </div>
        <Search>
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInputBase
            placeholder="Search…"
            inputProps={{ 'aria-label': 'search' }}
          />
        </Search>
        <Link href={ROUTES.LOGIN} style={{ textDecoration: 'none', color: 'white', marginLeft: '1%' }} underline="none">
          <Button variant="contained" style={{ backgroundColor: '#432a48', marginLeft: '1%' }}>
            Login
          </Button>
        </Link>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
